import {
  CORE_LOAD_FBS_REQUEST,
  CORE_LOAD_FBS_SUCCESS,

} from '../../types'

const initialState = []

export default {
  orders: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_FBS_REQUEST:
        return []
      case CORE_LOAD_FBS_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/features/fb/reducer.js